export default __webpack_public_path__ + "static/media/IconDesc_CanePart.256.123276f4.png";